import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export interface EmailWithTLDValidatorError {
  email: true;
}

/**
 * Validate Email with TLD at teh end. The default Validators.
 * Email allow email without TLD like foo@bar. We don't want that.
 * @param control
 * @returns
 */
export const EmailWithTLDValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const REGEX_NAME = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$'; // @@@
  const regexp = new RegExp(REGEX_NAME);
  return !control.value || regexp.test(control.value) ? null : ({ email: true } as EmailWithTLDValidatorError);
};
